import { render, staticRenderFns } from "./sopa_letras.vue?vue&type=template&id=361cc06c"
import script from "./sopa_letras.vue?vue&type=script&lang=js"
export * from "./sopa_letras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports